export const PERMISSION_COLUMNS = [
  {
    id: "name",
    label: "Name",
    editable: true,
    type: "text",
    width: "150",
    show: true,
    resizable: true,
  },
  {
    id: "description",
    label: "Description",
    editable: true,
    type: "text",
    width: "500",
    show: true,
    resizable: true,
  },
  {
    id: "tags",
    label: "Tags",
    sortable: false,
    type: "array",
    width: "250",
    show: true,
    resizable: true,
  },
  {
    id: "notes",
    label: "Notes",
    editable: true,
    type: "text",
    width: "250",
    show: true,
    resizable: true,
  },
];
